import React, { useMemo, useState } from 'react';

// Components
import TextField from '@material-ui/core/TextField';
import { Spacer, Button, Loader } from 'components';

// Validation
import { useFormik } from 'formik';
import * as yup from 'yup';

import getConfig from 'next/config';
import useAuthentication from 'utils/useAuthentication';

const validationSchema = yup.object({
    firstName: yup.string('Indtast dit fornavn').required('Fornavn er krævet'),
    lastName: yup.string('Indtast dit efternavn').required('Efternavn er krævet'),
    email: yup.string('Indtast din e-mail adresse').email('Indtast en gyldig e-mail adresse').required('E-mail adresse er krævet'),
    phone: yup.string('Indtast dit telefonnummer').required('Telefonnummer er krævet'),
    accepted: yup.boolean().oneOf([true], 'Du skal acceptere at dele dine oplysninger med os.'),
});

export default function JuraOrderForm({ handleOrder, selectedProducts }) {
    const [loading, setLoading] = useState(false);
    const { publicRuntimeConfig } = getConfig();
    const { authenticated } = useAuthentication();
    const formik = useFormik({
        initialValues: { firstName: '', lastName: '', email: '', phone: '', accepted: false },
        validationSchema,
        onSubmit: async ({ firstName, lastName, email, phone }) => {
            setLoading(true);
            try {
                const customer = { firstName, lastName, email, phone };
                handleOrder(customer);

            } catch (error) {
                setLoading(false);
            }
        },
    });
    return authenticated ? (
        <div style={{}}>
            <ol>
                <li>Bestil juridisk rådgivning ved at klikke på knappen ‘{ selectedProducts.filter(x => x).length > 1 ? 'Bestil produkter' : 'Bestil produkt' }’.</li>
                <li>Book første møde direkte i advokatens kalender.</li>
                <li>
                    Svar på en række spørgsmål og del svarene med advokaten, så advokaten kan forberede sig grundigt til mødet.
                </li>
            </ol>
            <Button onClick={ () => handleOrder(undefined) }>{ selectedProducts.filter(x => x).length > 1 ? 'Bestil produkter' : 'Bestil produkt' }</Button>
        </div>

    ) : (
        <section className="contactForm">
            <form onSubmit={ formik.handleSubmit } id="contact">
                <div>
                    <div className="formgroups">
                        <div className="formgroup">
                            <TextField
                                label="Fornavn"
                                name="firstName"
                                variant="filled"
                                value={ formik.values.firstName }
                                onChange={ formik.handleChange }
                                onBlur={ formik.handleBlur }
                                error={ formik.touched.firstName && Boolean(formik.errors.firstName) }
                                helperText={ formik.touched.firstName && formik.errors.firstName }
                            />
                        </div>
                        <div className="formgroup">
                            <TextField
                                label="Efternavn"
                                name="lastName"
                                variant="filled"
                                value={ formik.values.lastName }
                                onChange={ formik.handleChange }
                                onBlur={ formik.handleBlur }
                                error={ formik.touched.lastName && Boolean(formik.errors.lastName) }
                                helperText={ formik.touched.lastName && formik.errors.lastName }
                            />
                        </div>
                    </div>
                    <div className="formgroups">
                        <div className="formgroup">
                            <TextField
                                label="E-mailadresse"
                                name="email"
                                variant="filled"
                                value={ formik.values.email }
                                onChange={ formik.handleChange }
                                onBlur={ formik.handleBlur }
                                error={ formik.touched.email && Boolean(formik.errors.email) }
                                helperText={ formik.touched.email && formik.errors.email }
                            />
                        </div>
                        <div className="formgroup">
                            <TextField
                                label="Telefon"
                                name="phone"
                                variant="filled"
                                value={ formik.values.phone }
                                onChange={ formik.handleChange }
                                onBlur={ formik.handleBlur }
                                error={ formik.touched.phone && Boolean(formik.errors.phone) }
                                helperText={ formik.touched.phone && formik.errors.phone }
                            />
                        </div>
                    </div>

                    <Spacer />

                    <div className="formgroups">
                        <div className="formgroup">
                            <div className="checkbox" style={{ margin: 0 }}>
                                <input name="accepted" id="accepted" type="checkbox" value={ formik.values.accepted } onChange={ formik.handleChange } />
                                <label htmlFor="accepted">Jeg bekræfter, at Penly må kontakte mig på e-mail og telefon angående min bestilling.</label>
                            </div>
                        </div>
                    </div>
                    { formik.touched.accepted && <p className="validationError">{ formik.errors.accepted }</p> }
                    <Spacer />
                    <div>
                        <Button type="submit">{ selectedProducts.filter(x => x).length > 1 ? 'Bestil produkter' : 'Bestil produkt' }</Button>
                    </div>
                </div>
            </form>
        </section>
    );
}
